/**
 * BudChampion Quick Buy frontend entry.
 */
import { createController } from './controller.js';
import { clearOptionsCache } from './api/product-options.js';
import { initPackSelectors } from './pack-selector.js';
import { initWishlist } from './wishlist/carousel.js';
import {
	initTiWishlistBridge,
	syncTiWishlistFromPackForms,
	debugTiWishlistReport,
	BRIDGE_VERSION,
} from './integrations/ti-wishlist.js';

(function boot() {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}

	const controller = createController();

	function init() {
		controller.bind();
		initTiWishlistBridge();
		initPackSelectors();
		syncTiWishlistFromPackForms();
		initWishlist();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	window.BCQuickBuy = {
		clearOptionsCache,
		initPackSelectors,
		initWishlist,
		debugTiWishlist: debugTiWishlistReport,
		version: BRIDGE_VERSION,
	};
})();
